export const CONFIG = {
  "PROJECTNAME": "dalyan",
  "COMPANYNAME": "Dalyan",
  "DFTLNGCODE": "de",
  "URL": "https://api.fbsshop.de",
  "PAYMENTSERVER": "https://stripe.mobiapi.de",
  "VENDORID": "10010075",
  "IMAGEURL": "/images",
  "PAYMENTSYSTEM": false,
  "BANNER": false,
  "BRANDS": false,
  "FLAG_ITEM_ON_HAND": false,
  "MENU_LOGO_BACKGROUND": false,
  "LOGO_LOGIN_BACKGROUND": false,
  "MENU_WHITE_BACKGROUND": false,
  "colors": {
    "primary": "rgba(23,100,192,255)",
    "primary100": "rgba(23,100,192,0.15)",
    "light": "rgba(23,100,192,255)",
    "secondary": "rgba(23,100,192,255)",
    "dark": "#d6d7df",
    "siteColor3": "#fff",
    "menuSecondary": "rgba(23,100,192,255)"
  }
};